import React, { useEffect } from "react";
import Layout from "../components/Layout/Layout";
import ReadMail from "../components/ReadMail/ReadMail";
import { useParams } from "react-router-dom";

import { readMailInbox } from "../features/mail/mailSlice";
import { useSelector, useDispatch } from "react-redux";

const ReadMailScreen = () => {
  const dispatch = useDispatch();
  let params = useParams();

  const { inboxmail, isLoading } = useSelector((state) => state.mail);

  if (isLoading) {
    <div>Loading Data...</div>;
  }

  const getSender =
    inboxmail &&
    inboxmail.payload.headers[
      inboxmail.payload.headers.findIndex((item) => item.name === "From")
    ].value;

  const getDate =
    inboxmail &&
    inboxmail.payload.headers[
      inboxmail.payload.headers.findIndex((item) => item.name === "Date")
    ].value;

  const getSubject =
    inboxmail &&
    inboxmail.payload.headers[
      inboxmail.payload.headers.findIndex((item) => item.name === "Subject")
    ].value;

  useEffect(() => {
    dispatch(readMailInbox(params.mail, params.id));
  }, [dispatch, params.mail, params.id]);
  return (
    <Layout>
      {inboxmail && (
        <ReadMail
          sender={getSender}
          date={getDate}
          subject={getSubject}
          mailcontent={inboxmail.snippet}
        />
      )}
    </Layout>
  );
};

export default ReadMailScreen;
